const user_admin = ["admin@urbanice.app", "u15833112736235094", "u16024699849533371", "u16741097775772792", "u17120315335317183", "u17055527296566723", "u17363244873038556", "u17367644023637673", "u17301773546872822","u17193836786944520","u17193837755295934", "u17441017417458359","u17186800385617048", "u17097121603302793"];
//admin@urbanice.app 
//u16024699849533371 = pmc.ton@test.com
//u17120315335317183 = admin.touch@test.com
//u16741097775772792 = pmc1@moon.com 
//u15833112736235094 = pmc2@moon.com
//u17055527296566723 = bell38-74@hotmail.com (Bell URB)
//u17363244873038556 = natcha.n@thelivingos.com  (Naj)
//u17193837755295934 = phanuwat@thelivingos.com (Boy QA)
//u17193836786944520 = tidaporn@thelivingos.com (Nook QA)
//u17367644023637673 = kamon.s@thelivingos.com (Boy UX/UI)
//u17301773546872822 = patiphan.t@thelivingos.com (Park UX/UI)
//u17441017417458359 = graph_kv@hotmail.com (Graph PO)
//u17186800385617048 = nisanad.v@thelivingos.com (Ying)
//u17097121603302793 = phatcharapol@thelivingos.com(Pipe)

const user_sales = ["pmc3@test.com","u17097155592229500", "u17120444079073526", "u17085897426443754"];
//pmc3@test.com
//u17097155592229500 = ratree@thelivingos.com(Rung)
//u17120444079073526 = thanundorn@thelivingos.com(Yok)
//u17085897426443754 = ponprapa.c@thelivingos.com (Bow)


const user_sales_co = ["u17247335665959442","u17369232544520276"];
//u17247335665959442 = phannipha@thelivingos.com (Nuk)
//u17369232544520276 = kittiwara@thelivingos.com (Benz)


const user_cs = ["u17188531209322518", "u17207592845200243", "u17261300701710264","u17364068215861688", "u17471961249690972"];
//u17188531209322518 = wisarut.l@thelivingos.com (BB CS) 
//u17207592845200243 = jirat@thelivingos.com (Mick)
//u17261300701710264 = suchawee.b@thelivingos.com (Arabia CS)
//u17364068215861688 = kotchamonfern@gmail.com (Fern CS)
//u17471961249690972 = supakorn.s@thelivingos.com  (Pao CS)

const user_finance = ["u15989591378881476", "u17186900322549968", "u17219654942545976", "u17219695596699033"];
//u15989591378881476 = pmc4@moon.com
//u17186900322549968 = thitival.h@thelivingos.com (Mauy)
//u17219654942545976 = sataporn@thelivingos.com (Tae)
//u17219695596699033 = nongnuch@thelivingos.com (Nuch)

const user_marketer = ["u17186798109161229", "u17236320913439897"];
//u17186798109161229 = rawee.b@thelivingos.com (Tong)
//u17236320913439897 = ratchaneekorn.c@thelivingos.com (Nan)

export {  
    user_admin, 
    user_sales,
    user_sales_co,
    user_finance,
    user_cs,
    user_marketer,
}